import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";
import { MAIN_TABS } from "../../constants";

const sidebarMenuLinks = [
  {
    value: MAIN_TABS.LOG_BOOK,
    icon: "icon",
  },
  {
    value: MAIN_TABS.REPORTS,
    icon: "icon",
  },
  {
    value: MAIN_TABS.TRAINING,
    icon: "icon",
  },
  {
    value: MAIN_TABS.PROFILE,
    icon: "icon",
  },
  {
    value: MAIN_TABS.ADMIN,
    icon: "icon",
  },
  {
    value: MAIN_TABS.FORBIDDEN,
    icon: "icon",
  },
];
const initialState = {
  sidebarMenuLinks,
  activeTab: sidebarMenuLinks.find((tab) => tab.value === MAIN_TABS.TRAINING),
  sidebarShow: true,
};

export const layoutSlice = createSlice({
  name: "layout",
  initialState,
  reducers: {
    setActiveTab: (state, action: PayloadAction<any>) => {
      state.activeTab = action.payload;
    },
    setSidebarShow: (state, action: PayloadAction<any>) => {
      state.sidebarShow = action.payload;
    },
  },
});

export const { setActiveTab, setSidebarShow } = layoutSlice.actions;

export const getAllTabs = (state: RootState) => state?.layout?.sidebarMenuLinks;
export const getActiveTab = (state: RootState) => state?.layout?.activeTab;
export const getSidebarStatus = (state: RootState) => state?.layout?.sidebarShow;

export default layoutSlice.reducer;
